module.exports = __webpack_public_path__ + "img/nav7h.24a5710e.png";